import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// tailwind-merge muss die Elbklar-Typostile kennen, sonst bleiben bei
// cn('t-body', 't-small') beide Klassen stehen.
//
// Ebenso die Schriftgrößen der Eingabefelder (`text-field`, `text-field-sm`):
// Ohne den Eintrag hält tailwind-merge sie für Textfarben und wirft bei
// cn('text-field', 'text-foreground') eine von beiden weg.
const twMerge = extendTailwindMerge<'elbklar-typo'>({
  extend: {
    theme: { text: ['field', 'field-sm'] },
    classGroups: {
      'elbklar-typo': [
        't-display', 't-page-title', 't-stat', 't-title', 't-body', 't-body-strong',
        't-small', 't-label', 't-overline', 't-mono', 't-kbd',
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
